import ACTIONS from "../../constants/ACTIONS"

const initialState = {
  supportedIntegrations: [],
  teamIntegrations: [],
  verifyIntegration: null,
  updateIntegration: null,
}

export default function integrationsReducer(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.GET_SUPPORTED_INTEGRATIONS: {
      return {
        ...state,
        supportedIntegrations: action.payload,
      }
    }

    case ACTIONS.GET_TEAM_INTEGRATIONS: {
      return {
        ...state,
        teamIntegrations: action.payload,
      }
    }

    case ACTIONS.VERIFY_INTEGRATION: {
      return {
        ...state,
        verifyIntegration: action.payload,
      }
    }

    case ACTIONS.UPDATE_TEAM_INTEGRATION: {
      return {
        ...state,
        updateIntegration: action.payload,
      }
    }

    default:
      return { ...state }
  }
}

export { initialState as initialStateIntegrationsReducer }
